import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-7"
}
const _hoisted_2 = { class: "col-span-12" }
const _hoisted_3 = { key: 1 }

import AdminLayout from '@/layouts/AdminLayout.vue';
import TabComponent from '@/components/TabComponent.vue';
import FormSection from '@/components/FormSection.vue';
import QuantitySelector from '@/components/inputs/QuantitySelector.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import ActivityLogsTable from '@/components/ActivityLogsTable.vue';

import Setting from "@/classes/Setting";

import { useRoute, useRouter } from 'vue-router';
import { onMounted, ref, computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ViewPage',
  setup(__props) {

const route = useRoute();
const router = useRouter();

// Data
const loader    = ref(false);
const showError = ref(false);
const errorMsg  = ref(null);
const errors      = ref([])
const showSuccess = ref(false)
const showConfirmation = ref(false)

const item = ref(null);
const payload = computed(() => {
    return {
        id: route.params.id,
        count: item.value.count
    }
})

const currentRoutePath = computed(() => router.currentRoute.value.path);

const log_counts      = ref(0);
const logs            = ref({});

// Methods
const editSetting = () => {
    loader.value = true;

    Setting.editSetting(route.params.id)
        .then((response: any) => {
            loader.value = false;

            item.value = response.data.reservationCapacity;

            log_counts.value      = response?.data.log_counts
            logs.value            = response?.data.logs
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;
            
            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const updateSetting = () => {
    loader.value = true;

    Setting.updateSetting(route.params.id, payload.value)
        .then((response: any) => {
            loader.value = false;
            showSuccess.value = true;
            item.value = response.data.reservationCapacity;
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;

            if(err.response.status == 422) {
                errors.value = err.response.data.errors;
            }
            
            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const tabs: { name: string, count: number, href?: string, allowed: boolean}[] = computed(() => [
    {
        name: 'Information',
        count: 0,
        href: `/settings/edit/${route.params.id}`,
        allowed: true
    },
    {
        name: 'Activity logs',
        count: log_counts.value,
        href: `/settings/edit/${route.params.id}/logs`,
        allowed:
            window.$hasPermission('view-activity-logs')
    },
]);

onMounted( () => {
    editSetting();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "View Setting",
    "show-back": "",
    backUrl: "/settings"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(TabComponent, { tabs: tabs.value }, null, 8, ["tabs"])
      ]),
      (currentRoutePath.value !== `/settings/edit/${_unref(route).params.id}/logs`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(FormSection, null, {
              title: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode(" Reservation Capacity Per Course Information ", -1)
              ]))]),
              description: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode(" Relevant data and other details ", -1)
              ]))]),
              form: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-sm mb-6" }, "Reservation Capacity Per Course", -1)),
                  (item.value)
                    ? (_openBlock(), _createBlock(QuantitySelector, {
                        key: 0,
                        modelValue: payload.value.count,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.count) = $event)),
                        value: item.value.count,
                        id: "count",
                        name: "count"
                      }, null, 8, ["modelValue", "value"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              actions: _withCtx(() => [
                (_ctx.$hasPermission('manage-settings'))
                  ? (_openBlock(), _createBlock(ButtonComponent, {
                      key: 0,
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (showConfirmation.value = true), ["prevent"]))
                    }, {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createTextVNode(" Save Changes ", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(ActivityLogsTable, {
              logs: logs.value,
              onFetchIndex: editSetting
            }, null, 8, ["logs"])
          ])),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 2 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[3] || (_cache[3] = ($event: any) => (showError.value = false)),
        errors: errors.value
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show", "errors"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[4] || (_cache[4] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[5] || (_cache[5] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Confirm",
        title: "Reservation Capacity Updated!",
        content: "Reservation Capacity has been updated successfully"
      }, null, 8, ["show"]),
      _createVNode(ConfirmationModal, {
        show: showConfirmation.value,
        onCancel: _cache[6] || (_cache[6] = ($event: any) => (showConfirmation.value = false)),
        onConfirm: _cache[7] || (_cache[7] = ($event: any) => {showConfirmation.value = false; updateSetting() }),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Update Reservation Capacity?",
        content: "Are you sure you wish to update this Reservation Capacity?"
      }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})